function getCombatPrefix({ round, actionNumber, extraAttacks = false } = {}) {
  if (extraAttacks) {
    return `Round ${round ?? 0} Extra Attacks`
  }

  return `Round ${round ?? 0} Action ${actionNumber ?? 0}`
}

export default function formatCombatMessage({
  round,
  actionNumber,
  combatantName,
  message,
  extraAttacks = false,
} = {}) {
  if (!message) {
    return ''
  }

  const prefix = getCombatPrefix({ round, actionNumber, extraAttacks })

  if (combatantName && message.endsWith(` invalid for ${combatantName}`)) {
    return `${prefix} - ${message}`
  }

  const logMessage = `${message.charAt(0).toLowerCase()}${message.slice(1)}`

  if (combatantName) {
    return `${prefix} - ${combatantName} ${logMessage}`
  }

  return `${prefix} - ${logMessage}`
}
